/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Noeditpermission2Inputs */

const he_server_errors_noeditpermission2 = /** @type {(inputs: Server_Errors_Noeditpermission2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין לך הרשאה לערוך את הגדרות הארגון`)
};

const en_server_errors_noeditpermission2 = /** @type {(inputs: Server_Errors_Noeditpermission2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to edit this`)
};

/**
* | output |
* | --- |
* | "You do not have permission to edit this" |
*
* @param {Server_Errors_Noeditpermission2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_noeditpermission2 = /** @type {((inputs?: Server_Errors_Noeditpermission2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Noeditpermission2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_noeditpermission2(inputs)
	return en_server_errors_noeditpermission2(inputs)
});
export { server_errors_noeditpermission2 as "server_errors_noEditPermission" }